export default __webpack_public_path__ + "static/media/reflection.652cf6b8.webp";